import { alpha, styled } from '@mui/material/styles';
import { Box, Paper, ToggleButton, ToggleButtonGroup, InputBase, Button, Stack, IconButton, Chip } from '@mui/material';

export const StyledToolbarPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export const StyledSearchPaper = styled(Paper)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  borderRadius: theme.shape.borderRadius * 2,
  backgroundColor: 'transparent',
  border: `1px solid ${theme.palette.divider}`,
  '&:hover': {
    borderColor: theme.palette.primary.main,
  },
  transition: 'all 0.2s ease-in-out',
  paddingLeft: theme.spacing(1),
}));

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  minWidth: '300px',
  width: '100%',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 2),
    width: '100%',
  },
}));

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  '& .MuiToggleButton-root': {
    margin: theme.spacing(0.5),
    padding: theme.spacing(1, 2),
    textTransform: 'none',
  },
}));

export const StyledActionButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius * 2,
  padding: theme.spacing(1, 2),
  textTransform: 'none',
  fontWeight: 500,
  transition: 'all 0.2s ease-in-out',
  border: `1px solid ${theme.palette.divider}`,
  '&:hover': {
    borderColor: theme.palette.primary.main,
    backgroundColor: alpha(theme.palette.primary.main, 0.05),
  },
  '&.MuiButton-containedPrimary': {
    color: '#fff',
    backgroundColor: theme.palette.primary.main,
    border: 'none',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
      color: '#fff',
      border: 'none',
    },
  },
}));

export const StyledFilterChipsContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  padding: theme.spacing(1),
  backgroundColor: 'transparent',
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.divider}`,
}));

export const StyledToolsStack = styled(Stack)(({ theme }) => ({
  width: '100%',
  gap: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const StyledStageButton = styled(ToggleButton)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  '&.MuiToggleButton-root': {
    border: `1px solid ${theme.palette.divider}`,
  },
  '&.Mui-selected': {
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
    border: `1px solid ${theme.palette.primary.main}`,
  },
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  '& .MuiSvgIcon-root': {
    fontSize: '1.2rem',
    color: theme.palette.text.secondary,
  },
}));

export const StyledSortButton = styled(Button)(({ theme }) => ({
  minWidth: '120px',
  textTransform: 'none',
}));

export const StyledBetaChip = styled(Chip)(({ theme }) => ({
  background: theme.palette.warning.main,
  color: 'white',
}));

export const StyledFilterChip = styled(Chip)(({ theme }) => ({
  borderRadius: '25px',
  borderColor: theme.palette.primary.main,
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.1),
  },
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  marginRight: theme.spacing(1),
})); 